<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="2">
        <v-select 
          :items="query_targets" 
          v-model="query_target"
          item-text="text"
          item-value="ref" 
          solo dense></v-select>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field 
          label="Busca"
          v-model="query" 
          @click:append="search()" 
          append-icon="mdi-magnify" 
          v-on:keyup.enter="search()"
          solo dense>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-alert dense text type="info">
          {{ counter }} registros
        </v-alert>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn color="primary" @click="register()" block title="Novo">+</v-btn>
      </v-col>
      <v-col cols="12" sm="1" v-if="!$auth.isSubuser()">
        <v-btn color="secondary" @click="compels()" block title="Integração">
          <v-icon>mdi-connection</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="1" v-if="!$auth.isSubuser()">
        <v-btn color="success" @click="faturamento()" block title="Faturamento">
          <v-icon>mdi-currency-usd</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="1" v-if="$auth.isSubusername('adm') || !$auth.isSubuser()">
        <v-btn color="warning" @click="cobranca()" block title="Cobrança">
          <v-icon>mdi-currency-usd-off</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="1" v-if="$auth.isSubusername('adm') || !$auth.isSubuser()">
        <v-btn color="error" @click="bloqueio()" block title="Bloqueio">
          <v-icon>mdi-cancel</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn color="accent" @click="report()" block title="Relatórios">
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Plano</th>
          <th>Usuário</th>
          <th>Serial</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.clientName }}</td>
          <td>{{ item.planName }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.serial }}</td>
          <td><v-chip :color="colorStatus(item)" text-color="white" small>{{ item | formatStatus }}</v-chip></td>
          <td><v-btn icon :to="`/internet/${item.id}`"><v-icon>mdi-magnify</v-icon></v-btn></td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: [],
    counter: 0,
    query: "",
    query_target: "client",
    query_targets: [
      {ref: "client", text: "Cliente"},
      {ref: "serial", text: "Serial"},
      {ref: "username", text: "Usuário"}
    ],
    dialog_loading: false
  }),
  created: function() {
    this.count();
  },
  methods: {
    count: function() {
      var me = this;
      me.current = [];
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/internet/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.counter = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    details: function(item) {
      router.push({ path: `/internet/${item.id}` });
    },
    register: function (){
      router.push({path: "/internet/new"});
    },
    compels: function (){
      router.push({path: "/internet/compels"});
    },
    faturamento: function (){
      router.push({path: "/internet/faturamento"});
    },
    bloqueio: function (){
      router.push({path: "/internet/bloqueio"});
    },
    cobranca: function (){
      router.push({path: "/internet/cobranca"});
    },
    report: function (){
      router.push({path: "/internet/report"});
    },
    search: function() {
      var me = this;
      if(me.query==""){
        this.count();
        return;
      }
      if(me.query.length<3){
        alert("A busca precisa ter pelo menos 3 caracteres!");
        return;
      }
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/internet/"+this.query_target+"/"+this.query, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.counter = response.data.length;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar registros!");
        });
    },
    colorStatus: function(item){
      var color = "default";
      if (item.status==0){
        color = "success";
      }else if (item.status==1){
        color = "warning";
      }else if(item.status==2){
        color = "info";
      }else if(item.status==3){
        color = "error";
      }else if(item.status==4){
        color = "secondary";
      }
      return color;
    }
  },
  filters: {
    formatStatus: function(item){
      var text = "Desconhecido";
      if (item.status==0){
        text = "Habilitado";
      }else if (item.status==1){
        text = "Bloqueio administrador";
      }else if(item.status==2){
        text = "Bloqueio cliente";
      }else if(item.status==3){
        text = "Bloqueio pagamento";
      }else if(item.status==4){
        text = "Cancelado";
      }
      return text;
    }
  }
};
</script>